import { SavedPlaceList } from "./saved-places";

export interface UserRole {
  isSociabilityTeam: boolean;
  isSociabilityMapper: boolean;
  isDerbyUser: boolean;
  maxPhotoUploadAllowedByRole: string;
}
export default interface User {
  id: number;
  name: string;
  email: string;
  email_verification: number;
  status: number;
  ability: string;
  profilePhoto: string;
  profile_photo: string;
  profile_color_code: string;
  gender: string;
  yearOfBirth: number;
  accessibilityNeed: string;
  level: string;
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresAt: string;
  socialLoginStatus: string;
  roles: UserRole;
  first_name: string;
  last_name: string;
  badgeImages?: string[];
  account_preferences: any[];
  accessibility_need: string;
  linked_social_account: string;
  saved_places: SavedPlaceList[];
  t_and_c_accept: number;
}

export function userFromResponse(response: any): User | null {
  if (!response) return null;
  return {
    id: response.id,
    name: response.name,
    first_name: response.first_name,
    last_name: response.last_name,
    email: response.email,
    email_verification: response.email_verification,
    status: response.status,
    ability: response.ability,
    profilePhoto: response.profile_photo,
    profile_photo: response.profile_photo,
    profile_color_code: response.profile_color_code,
    gender: response.gender,
    yearOfBirth: response.year_of_birth,
    accessibilityNeed: response.accessibility_need,
    level: response.level,
    accessToken: response.access_token,
    refreshToken: response.refresh_token,
    tokenType: response.token_type,
    expiresAt: response.expires_at,
    socialLoginStatus: response.social_login_status,
    roles: {
      isSociabilityTeam: response.roles?.isSociabilityTeam ?? false,
      isSociabilityMapper: response.roles?.isSociabilityMapper ?? false,
      isDerbyUser: response.roles?.isDerbyUser ?? false,
      maxPhotoUploadAllowedByRole:
        response.roles?.maxPhotoUploadAllowedByRole ?? "0",
    },
    account_preferences: response.account_preferences,
    badgeImages: response.badge_images,
    accessibility_need: response.accessibility_need,
    linked_social_account: response.linked_social_account,
    saved_places: response.saved_places,
    t_and_c_accept: response.t_and_c_accept,
  };
}

export function isUserProfilePublic(user?: User): boolean {
  const preference = user?.account_preferences.find(
    (e) => e.key === "public_activities"
  );
  if (!preference) {
    return true;
  }
  return preference.value === "1";
}

export function isUserProfilePublicFromPrefs(preferences: any[]): boolean {
  const preference = preferences.find((e) => e.key === "public_activities");
  if (!preference) {
    return true;
  }
  return preference.value === "1";
}

export function isUserDisabilityPublic(user?: User): boolean {
  const preference = user?.account_preferences.find(
    (e) => e.key === "disability_visible"
  );
  if (!preference) {
    return true;
  }
  return preference.value === "1";
}
